import React from 'react'

import { Portlet, Row, Col, Button, Divider, Alert } from '_zari/core'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import { MovimientosTurnoModal } from 'sharedComponents/modals'

import * as CuadresCombustiblesService from 'services/cuadresCombustibles.service'

import RowTemplate from './rowTemplate'

const CuadresCombustiblesPage = () => {
  const __zariContext = React.useContext(ZariContext)
  const [combustiblesData, setCombustiblesData] = React.useState([])
  const [arrayActualSalidaInput, setArrayActualSalidaInput] = React.useState([])
  const [arrayVentasRecuperadas, setArrayVentasRecuperadas] = React.useState([])

  const __adminContext = React.useContext(AdminContext)

  const [mostrarMovimientosTurnoModal, setMostrarMovimientosTurnoModal] = React.useState(false)

  React.useEffect(() => {
    CuadresCombustiblesService.obtenerAsCuadresCombustibles().then(({ data }) => {
      setCombustiblesData(data)
      for (let i = 0; i < data.length; i++) {
        setArrayActualSalidaInput(prev => {
          let nuevoArraySalidaInput = [...prev]
          nuevoArraySalidaInput[i] = data[i].saldoActual
          return nuevoArraySalidaInput
        })
      }
    })
  }, [setArrayActualSalidaInput, setCombustiblesData])

  const refrescarCombustiblexIsla = React.useCallback(() => {
    CuadresCombustiblesService.obtenerAsCuadresCombustibles().then(({ data }) => {
      setCombustiblesData(data)
    })
  }, [])

  const clickRecuperarVentas = React.useCallback(() => {
    CuadresCombustiblesService.recuperarVentasDelTurno().then(({ data }) => {
      setArrayVentasRecuperadas(data)
    })
  }, [setArrayVentasRecuperadas])

  const guardarCuadresCombustibles = React.useCallback(() => {
    if (combustiblesData.length === arrayActualSalidaInput.length) {
      let data = []
      for (let i = 0; i < combustiblesData.length; i++) {
        const combustibleDataActual = combustiblesData[i]
        data[i] = {
          idIsla: combustibleDataActual.idIsla,
          lado: combustibleDataActual.lado,
          combustible: combustibleDataActual.combustible,
          lecturaActual: arrayActualSalidaInput[i],
          lecturaAnterior: combustibleDataActual.saldoAnterior
        }
      }
      CuadresCombustiblesService.guardarCuadresCombustiblesAsArray({ data, arrayVentasRecuperadas: arrayVentasRecuperadas }).then(() => {
        refrescarCombustiblexIsla()
        __zariContext.snack('success', 'Se registraron los cuadres')
      })
    } else {
      __zariContext.snack('error', 'Todos los campos son requeridos')
    }
  }, [arrayActualSalidaInput, combustiblesData, __zariContext, refrescarCombustiblexIsla, arrayVentasRecuperadas])

  return (
    <>
      {__adminContext.estadoTurno ? (
        <>
          <Portlet>
            <Portlet.Header title='Cuadres Combustibles' buttons={[{ name: 'Movimientos del Turno', onClick: () => setMostrarMovimientosTurnoModal(true) }]} />
            <Portlet.Body>
              <Row className='mb-2'>
                <Col md={12} className='text-right'>
                  <Button outline tiny onClick={clickRecuperarVentas}>
                    Recuperar Ventas
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <table border='1' width='100%'>
                    <thead>
                      <tr>
                        <th>Isla</th>
                        <th>Lado</th>
                        <th>Combustible</th>
                        <th>
                          Actual <br /> (Salida)
                        </th>
                        <th>
                          Anterior <br /> (Entrada)
                        </th>
                        <th>
                          Total <br /> Despachado
                        </th>
                        <th>
                          Total <br /> Venta Externa
                        </th>
                        <th>
                          Total <br /> Diferencia
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <RowTemplate
                        combustiblesData={combustiblesData}
                        arrayActualSalidaInput={arrayActualSalidaInput}
                        setArrayActualSalidaInput={setArrayActualSalidaInput}
                        arrayVentasRecuperadas={arrayVentasRecuperadas}
                        setArrayVentasRecuperadas={setArrayVentasRecuperadas}
                      ></RowTemplate>
                    </tbody>
                  </table>
                  <Divider></Divider>
                  <Row>
                    <Col md={10} />
                    <Col md={2}>
                      <Button color='primary' onClick={guardarCuadresCombustibles}>
                        Guardar
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Portlet.Body>
          </Portlet>
        </>
      ) : (
        <Alert color='danger'>Esta función requiere aperturar turno.</Alert>
      )}
      {mostrarMovimientosTurnoModal && (
        <MovimientosTurnoModal
          show={mostrarMovimientosTurnoModal}
          handleClose={() => {
            setMostrarMovimientosTurnoModal(false)
          }}
          self
        />
      )}
    </>
  )
}

export default React.memo(CuadresCombustiblesPage)
